import { css } from "@emotion/core"
import { theme } from "../../atoms/constants"

export const primaryheaderStyle = css`
  width: 100%;
  ${theme.presets.flexXYCentered};
`
export const primaryButtonStyle = css`
  margin-right: 1em;
`
export const backgroundStyle = css`
  height: 10vh;
  width: 80vw;
  background: #17143d;
  padding: 1em;
`
